exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pie-chart-block[data-v-431f9924]{max-width:100%}.pie-chart-block .chart-title[data-v-431f9924]{font-size:12px;line-height:16px;font-weight:700}\n", ""]);
